import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

const ServiceCard = ({ heading, image, description, linkText='' }) => {
  return (
    <div className="w-full max-w-sm rounded overflow-hidden shadow-md bg-emerald-50 px-4 mx-auto group hover:shadow-lg cursor-pointer">
      <img
        className="w-3/4 h-32 mx-auto my-4 transition-transform duration-300 transform group-hover:scale-105 cursor-pointer"
        src={image}
        alt={heading}
      />
      <div className="px-4 py-1 text-center">
        <div className="font-semibold text-base mb-4 cursor-pointer">
          {heading}
        </div>
        <p className="text-gray-500 text-xs text-center mb-4">
          {description}
        </p>
        <Link 
         to={linkText}
         onClick={() => window.scrollTo(0, 0)}
         className="text-emerald-600 px-2 py-1 rounded-lg font-semibold hover:text-emerald-700 transition duration-300">
          Learn More
        </Link>
      </div>
    </div>
  );
};

ServiceCard.propTypes = {
  heading: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  linkText: PropTypes.string.isRequired,
};

export default ServiceCard;
